import React from 'react'
import InfoTooltip from '../../../components/InfoTooltip/InfoTooltip'
import classes from './LabelBlock.module.less'

type LabelBlockProps = {
    label?: string
    required?: boolean
    infoText?: string
    labelStyle?: React.CSSProperties
}

export const LabelBlock: React.FC<LabelBlockProps> = ({
    label,
    required = false,
    infoText,
    labelStyle,
}) => {
    if (!label && !infoText) {
        return null
    }

    if (!label && infoText) {
        return (
            <span>
                <InfoTooltip title={infoText} />
            </span>
        )
    }

    return (
        <div className={classes.container}>
            <div style={labelStyle}>
                {label}
                {required && <span className={classes.required}>*</span>}
            </div>
            {infoText && <InfoTooltip title={infoText} />}
        </div>
    )
}
